import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  bgImg: {
    logo_img_url: '../assets/top_logo@2x.png',
    title_img_url: '../assets/index_logo@2x.png',
    // case_bg_img_url: '',
    case_bg_img_url_left: '../assets/CompanyCase_bg_l@2x.png',
    case_bg_img_url_right: '../assets/CompanyCase_bg_r@2x.png',
    foot_bg_img_url: '../assets/phoneContactUs_bg@2x.png',
    dynamics_bg_img_url: '',
    dynamics_detail_bg_img_url: '../assets/trends_bg@2x.png',
  },
  isPhone: false
}

const mutations = {
  changeBgImg(state, val) {
    state.bgImg = val
  },
  changeIsPhone(state, val) {
    state.isPhone = val
  }
}

const store = new Vuex.Store({
  state,
  mutations,
})

export default store